import { MessageTransport } from './type';

export default class InjectedMessageHandlerTransport<IncomingMessage, OutgoingMessage>
  implements MessageTransport<IncomingMessage, OutgoingMessage>
{
  constructor(
    public sessionId: string,
    public onMessage: (incomingMessage: IncomingMessage) => void,
    public sendMessage: (outgoingMessage: OutgoingMessage) => void,
    public closeMessageTransport: () => void,
  ) {
    window.prex ??= {};
    window.prex.messageHandlers ??= {};
    window.prex.messageHandlers[sessionId] = onMessage;
  }

  close() {
    this.closeMessageTransport();
    delete window.prex?.messageHandlers?.[this.sessionId];
  }
}
